<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%">
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.year" type="text" size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[12710]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.monthstart"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[12711]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.monthend"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                        </tr>
                    </table>
                </div>
                <div >
                    <el-tabs :tab-position="'top'" style="margin-top: 5px" v-model="activeName" @tab-click="selectInfo" >
                        <el-tab-pane :label="$t('getapi[8243]')" name="0" id="xpane-0">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="download(0)">{{$t('getapi[6506]')}}</el-button>
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove"
                                        :on-change="handleChange"
                                        :on-success="handleSuccess"
                                        :on-error="handleError"
                                        :file-list="fileList"
                                        :limit="1"
                                        accept=".xlsx"
                                        style="margin-left: 8px"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="imp(0)" style="margin-left: 5px">{{$t('getapi[370]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable"
                                    :data="dataSet"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <vxe-table-column field="material_cost" :title="$t('getapi[8244]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.material_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="man_cost" :title="$t('getapi[8245]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.man_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.charge_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8247]')" name="1" id="xpane-1">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="download(1)">{{$t('getapi[6506]')}}</el-button>
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl1"
                                        :on-preview="handlePreview1"
                                        :on-remove="handleRemove1"
                                        :on-change="handleChange1"
                                        :on-success="handleSuccess1"
                                        :on-error="handleError1"
                                        :file-list="fileList1"
                                        :limit="1"
                                        accept=".xlsx"
                                        style="margin-left: 8px"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="imp(1)" style="margin-left: 5px">{{$t('getapi[370]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable1"
                                    :data="dataSet1"
                                    v-loading="loading1"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[3437]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[546]')" width="100"></vxe-table-column>-->
                                <vxe-table-column show-overflow-tooltip field="material_cost" :title="$t('getapi[8244]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="man_cost" :title="$t('getapi[8245]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8248]')" name="2" id="xpane-2">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="download(2)">{{$t('getapi[6506]')}}</el-button>
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl2"
                                        :on-preview="handlePreview2"
                                        :on-remove="handleRemove2"
                                        :on-change="handleChange2"
                                        :on-success="handleSuccess2"
                                        :on-error="handleError2"
                                        :file-list="fileList2"
                                        :limit="1"
                                        accept=".xlsx"
                                        style="margin-left: 8px"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="imp(2)" style="margin-left: 5px">{{$t('getapi[370]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable2"
                                    :data="dataSet2"
                                    v-loading="loading2"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2584]')" width="100"></vxe-table-column>-->
                                <vxe-table-column show-overflow-tooltip field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8274]')" name="3" id="xpane-3">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="download(3)">{{$t('getapi[6506]')}}</el-button>
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl3"
                                        :on-preview="handlePreview3"
                                        :on-remove="handleRemove3"
                                        :on-change="handleChange3"
                                        :on-success="handleSuccess3"
                                        :on-error="handleError3"
                                        :file-list="fileList3"
                                        :limit="1"
                                        accept=".xlsx"
                                        style="margin-left: 8px"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="imp(3)" style="margin-left: 5px">{{$t('getapi[370]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable3"
                                    :data="dataSet3"
                                    v-loading="loading3"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="material_cost" :title="$t('getapi[8244]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="man_cost" :title="$t('getapi[8245]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_finscrapcostshare',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                btn: {
                    execute: true,
                },
                dataDetail:{
                    year: '',
                    monthstart:'',
                    monthend:''
                },
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                loading: false,
                SelectIndex: 0,
                // 系统外成本
                activeName: '0', // 当前选择的分页
                uploadurl: '',
                dataSet: [],
                fileList: [],
                fileUrl: '',
                uploadurl1: '',
                dataSet1: [],
                fileList1: [],
                fileUrl1: '',
                uploadurl2: '',
                dataSet2: [],
                fileList2: [],
                fileUrl2: '',
                uploadurl3: '',
                dataSet3: [],
                fileList3: [],
                fileUrl3: '',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
            };
        },
        beforeDestroy(){
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                });
            },
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/CostCalc/InvView/FinOutCostShareImportUpload?token=' + token;
            that.uploadurl1 = Common.Url + '/CostCalc/InvView/FinOutCostShareImportUpload?token=' + token;
            that.uploadurl2 = Common.Url + '/CostCalc/InvView/FinOutCostShareShipImportUpload?token=' + token;
            that.uploadurl3 = Common.Url + '/CostCalc/InvView/FinOutCostShareImportUpload?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.dataDetail.year = new Date().getFullYear()
            that.dataDetail.monthstart = new Date().getMonth() + 1
            that.dataDetail.monthend = new Date().getMonth() + 1
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8249]"),this.$t("getapi[8045]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            /*系统外成本*/
            download(type){
                let that = this
                let param={}
                if(type == 0){
                    param = {
                        url:'/CostCalc/InvView/GetFinOutCostShareCustImportTemplate'
                    }
                } else if(type == 1){
                    param = {
                        url:'/CostCalc/InvView/GetFinOutCostShareItemImportTemplate'
                    }
                } else if(type == 2){
                    param = {
                        url:'/CostCalc/InvView/GetFinOutCostShareShipImportTemplate'
                    }
                } else if(type == 3){
                    param = {
                        url:'/CostCalc/InvView/GetFinOutCostShareCustImportTemplate'
                    }
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.dt.length>0){
                            that.fileUrl = file.response.DataContent.URL
                            that.dataSet = file.response.DataContent.dt;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    if(res.DataContent.dt.length>0){
                        that.fileUrl = res.DataContent.URL
                        that.dataSet = res.DataContent.dt;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange1(file, fileList) {
                let that = this;
                that.loading1 = true;
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.dt.length>0){
                            that.fileUrl1 = file.response.DataContent.URL
                            that.dataSet1 = file.response.DataContent.dt;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading1 = false;
                }
            },
            handleSuccess1(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    if(res.DataContent.dt.length>0){
                        that.fileUrl1 = res.DataContent.URL
                        that.dataSet1 = res.DataContent.dt;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
                }
                that.fileList1=[];
            },
            handleError1(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove1(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview1(file) {
                console.log("handlePreview"+file);
            },
            handleChange2(file, fileList) {
                let that = this;
                that.loading2 = true;
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.dt.length>0){
                            that.fileUrl2 = file.response.DataContent.URL
                            that.dataSet2 = file.response.DataContent.dt;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading2 = false;
                }
            },
            handleSuccess2(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    if(res.DataContent.dt.length>0){
                        that.fileUrl2 = res.DataContent.URL
                        that.dataSet2 = res.DataContent.dt;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
                }
                that.fileList2=[];
            },
            handleError2(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove2(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview2(file) {
                console.log("handlePreview"+file);
            },
            handleChange3(file, fileList) {
                let that = this;
                that.loading3 = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.dt.length>0){
                            that.fileUrl3 = file.response.DataContent.URL
                            that.dataSet3 = file.response.DataContent.dt;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading3 = false;
                }
            },
            handleSuccess3(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    if(res.DataContent.dt.length>0){
                        that.fileUrl3 = res.DataContent.URL
                        that.dataSet3 = res.DataContent.dt;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
                }
                that.fileList3=[];
            },
            handleError3(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove3(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview3(file) {
                console.log("handlePreview"+file);
            },
            imp(type){
                let that = this
                let parm = {
                    just_year: that.dataDetail.year,
                    just_month_start: that.dataDetail.monthstart,
                    just_month_end: that.dataDetail.monthend,
                    order_type: type,
                    MultyVer: 0,
                    iTemplate: type,
                    FilePath: that.fileUrl
                }
                if(type == 0){
                    parm.FilePath = that.fileUrl
                } else if(type == 1){
                    parm.FilePath = that.fileUrl1
                } else if(type == 2){
                    parm.FilePath = that.fileUrl2
                } else if(type == 3){
                    parm.FilePath = that.fileUrl3
                }
                that.$http.urlpost('/CostCalc/InvView/FinOutCostShareImportData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
